export default {
    generalSettings: 'Réglages Généraux',
    changeDisplayLanguage: 'Langue d\'affichage',
    changeDisplayLanguageInfo: 'Choisissez votre langue par défaut préférée',
    nav: {
        audits: 'Audits',
        vulnerabilities: 'Vulnérabilités',
        data: 'Données',
    },
    btn: {
        cancel: 'Annuler',
        confirm: 'Confirmer',
        create: 'Créer',
        restore: 'Restaurer',
        ok: 'ok',
        leave: 'Partir',
        stay: 'Rester',
        topButtonSection: {
            submitReview: 'Soumettre les modifications',
            cancelReview: 'Annuler les modifications',
            approve: 'Accepter',
            removeApproval: 'Retirer l\'approbation',
            createRetest: 'Créer un Retest',
            navigateRetest: 'Accéder au Retest'
        },
        backupFinding: "Proposer la création  / Mettre à jour dans la base de données",
        delete: 'Supprimer',
        save: 'Sauvegarder',
        update: 'Modifier',
        deleteAll: 'Tout Supprimer',
        enable: 'Activer',
        valid: 'Validées',
        new: 'Nouvelles',
        updates: 'Modifiées',
    },
    tooltip: {
        usersConnected: 'Utilisateurs sur l\'Audit:',
        editAudit: 'Modifier l\'Audit',
        downloadReport: 'Télécharger le Rapport',
        deleteAudit: 'Supprimer l\'Audit',
        removeAudit: 'Retirer l\'Audit (l\'Audit ne sera pas supprimé)',
        topButtonSection: {
            submitReview: 'Marquer l\'audit comme prêt pour examin',
            cancelReview: 'Apporter des modifications à l\'audit',
            approve: 'Approuver cet audit',
            removeApproval: 'Retirer l\'approbation',
            createRetest: 'Créer un Retest pour cet Audit',
            navigateRetest: 'Naviguer vers le Retest de cet Audit'
        },
        sortOptions: 'Options de tri',
        addToFindings: 'Ajouter aux découvertes',
        edit: 'Modifier',
        view: 'Voir',
        findAudits: 'Rechercher des Audits',
        delete: 'Supprimer',
        download: 'Télécharger',
        retestSplitView: 'Activer la vue partagée avec les données de la vulnérabilité originale',
        addAudit: 'Ajouter l\'Audit',
        restoreRevert: "Restaure à l'état de la sauvegarde. Toutes les données non présentes dans la sauvegarde seront effacées",
        restoreUpsert: "Restaure les données de la sauvegarde et met à jour les données existantes. Si les données existent déjà, elles seront mises à jour, sinon elles seront crées",
    },
    msg: {
        auditReviewUpdateOk: 'État de l\'examin d\'audit mis à jour avec succès',
        auditApprovalUpdateOk: 'L\'approbation de l\'audit a été mise à jour avec succès',
        auditUpdateOk: 'Audit mis à jour avec succès',
        findingCreateOk: 'Découverte créée avec succès',
        findingUpdateOk: 'Découverte modifiée avec succès',
        findingDeleteOk: 'Découverte supprimée avec succès',
        doYouWantToLeave: 'Voulez-vous vraiment partir ?',
        thereAreUnsavedChanges: 'Il y a des modifications non enregistrées !',
        fieldRequired: 'Veuillez remplir tous les champs obligatoires',
        deleteFindingConfirm: 'Supprimer la découverte actuelle ?',
        deleteFindingNotice: 'Cette action ne peut pas être annulée',
        selectHost: 'Sélectionnez les hôtes',
        importHostsFirst: 'Saisir les hôtes en premier',
        auditTypeNotSet: 'Type d\'audit non défini',
        sectionUpdateOk: 'Section mise à jour avec succès',
        lastnameRequired: 'Nom requis',
        firstnameRequired: 'Prénom requis',
        emailRequired: 'E-mail requis',
        clientCreatedOk: 'Client créé avec succès',
        clientUpdatedOk: 'Client modifié avec succès',
        clientDeletedOk: 'Client supprimé avec succès',
        deleteNotice: 'sera définitivement supprimé',
        confirmSuppression: 'Confirmer la suppression',
        confirmRestore: 'Confirmer la restauration',
        restoreNotice: 'sera restaurée et pourrait mener à la perte des données existantes',
        usernameRequired: 'Nom d\'utilisateur requis',
        passwordRequired: 'Mot de passe requis',
        currentPasswordRequired: 'Mot de passe actuel requis',
        confirmPasswordDifferents: 'Le nouveau mot de passe et la confirmation du mot de passe sont différents',
        collaboratorCreatedOk: 'Collaborateur créé avec succès',
        collaboratorUpdatedOk: 'Collaborator modifié avec succès',
        collaboratorDeletedOk: 'Collaborator supprimé avec succès',
        nameRequired: 'Nom requis',
        fileRequired: 'Fichier requis',
        companyCreatedOk: 'Entreprise créée avec succès',
        companyUpdatedOk: 'Entreprise modifiée avec succès',
        companyDeletedOk: 'Entreprise supprimée avec succès',
        templateNotFound: 'Modèle introuvable',
        templateCreatedOk: 'Modèle créé avec succès',
        templateUpdatedOk: 'Modèle modifié avec succès',
        allVulnerabilitesDeleteNotice: 'Toutes les vulnérabilités seront définitivement supprimées',
        allVulnerabilitesDeleteOk: 'Toutes les vulnérabilités ont été supprimées avec succès',
        profileUpdateOk: 'Mise à jour du profil réussie',
        settingsUpdatedOk: 'Paramètres mis à jour avec succès',
        revertingSettings: 'Rétablir les paramètres ! ',
        revertingSettingsConfirm: 'Souhaitez-vous vraiment rétablir les paramètres par défaut ? Vous perdrez tous les paramètres actuels.',
        importingSettings: 'Importation des paramètres !',
        importingSettingsConfirm: 'Souhaitez-vous vraiment importer les nouveaux paramètres ? Vous perdrez tous les paramètres actuels qui sont remplacés.',
        settingsImportedOk: 'Paramètres importés avec succès',
        vulnerabilityCreatedOk: 'Vulnerabilité créée avec succès',
        vulnerabilityUpdatedOk: 'Vulnerabilité modifiée avec succès',
        vulnerabilityDeletedOk: 'Vulnerabilité supprimée avec succès',
        vulnerabilityWillBeDeleted: 'La vulnérabilité sera définitivement supprimée',
        confirmCategoryChange: 'Confirmer le changement de catégorie',
        categoryChangingNotice: 'L\'affichage des champs personnalisés peut être affecté lors du changement de catégorie',
        vulnerabilityMergeOk: 'Fusion des vulnérabilités réussie',
        tryingToContactBackend: '<p>Essaie de contacter le backend</p>',
        wrongContactingBackend: 'Une erreur s\'est produite lors du contact avec le backend',
        highlightWarningTitle: 'Texte Surligné toujours présent !',
        noAuditTypeForThisStage: 'Aucun type d\'Audit pour cette phase'
    },
    err: {
        notDefinedLanguage: 'Non défini pour cette langue',
        invalidYamlFormat: 'Format YAML invalide détecté',
        parsingError1: 'Erreur de parsing: {0}',
        parsingError2: 'Erreur de parsing: line {0}, column: {1}',
        invalidJsonFormat: 'Format JSON invalide détecté',
        jsonMustBeAnObject: 'JSON doit être un objet.',
        importingSettingsError: 'Erreur lors de l\'importation des paramètres',
        errorWhileParsingJsonContent: 'Erreur lors du parsing du contenu JSON : {0}',
        titleRequired: 'Titre requis',
        expiredToken: 'Token expiré',
        invalidToken: 'Token invalide',
        invalidCredentials: 'Identifiants invalides',
    },
    cvss: {
        title: 'Score de base CVSSv3',
        infoWhenNoScore: 'Sélectionnez des valeurs pour toutes les métriques de base pour générer un score ',
        attackVector: 'Vecteur d\'attaque',
        attackComplexity: 'Complexité d\'attaque',
        privilegesRequired: 'Privilèges requis',
        userInteraction: 'Interaction de l\'utilisateur',
        scope: 'Périmètre',
        confidentialityImpact: 'Impact sur la Confidentialité',
        integrityImpact: 'Impact sur la Intégrité',
        availabilityImpact: 'Impact sur la Disponibilité',
        network: 'Réseau',
        adjacentNetwork: 'Réseau Adjacent',
        local: 'Local',
        physical: 'Physique',
        low: 'Bas',
        high: 'Haut',
        none: 'Nul',
        required: 'Requis',
        unchanged: 'Inchangé',
        changed: 'Changé',
    },
    registerFirstUser: 'Enregistrer le premier utilisateur',
    customData: 'Données Personnalisées',
    custom: 'Personnalisé',
    settings: 'Paramètres',
    profile: 'Profil',
    logout: 'Déconnexion',
    login: 'Connexion',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    noLanguage: 'Aucune Langue n\'est définie. Veuillez créer des Langues dans ',
    noAudit: 'Aucun type d\'Audit n\'est défini. Veuillez créer des types d\'Audit dans ',
    auditTypes: 'Types d\'Audit',
    auditType: 'Type d\'Audit',
    searchFinds: 'Rechercher une découverte',
    myAudits: 'Mes Audits',
    usersConnected: 'Utilisateur Connecté',
    awaitingMyReview: 'En attente de mon examin',
    newAudit: 'Nouvel Audit',
    search: 'Rechercher',
    users: 'Utilisateurs',
    auditNum1: 'Audit',
    auditNums: 'Audits',
    resultsPerPage: 'Resultats par page:',
    createAudit: 'Créer un Audit',
    name: 'Nom',
    selectAssessment: 'Sélectionnez le type d\'Audit',
    selectLanguage: 'Choisir la langue',
    participants: 'Participants',
    language: 'Langue',
    company: 'Entreprise',
    companies: 'Entreprises',
    date: 'Date',
    sections: 'Sections',
    generalInformation: 'Informations Générales',
    networkScan: 'Scan Réseau',
    findings: 'Découvertes',
    automaticSorting: 'Tri automatique',
    sortBy: 'Trier Par',
    sortOrder: 'Ordre de tri',
    ascending: 'Croissant',
    descending: 'Décroissant',
    me: 'moi',
    cvssScore: 'Score CVSS',
    priority: 'Priorité',
    remediation: 'Remédiation',
    remediationDifficulty: 'Difficulté de Remédiation',
    remediationComplexity: 'Complexité de Remédiation',
    remediationPriority: 'Priorité de Remédiation',
    easy: 'Facile',
    medium: 'Moyenne',
    complex: 'Complexe',
    low: 'Basse',
    high: 'Haute',
    urgent: 'Urgente',
    title: 'Titre',
    category: 'Categorie',
    selectCategory: 'Choisir une catégorie',
    noCategory: 'Aucune catégorie',
    vulnType: 'Type',
    undefined: 'Non défini',
    vulnerabilityNum1: 'Vulnerabilité',
    vulnerabilitiesNums: 'Vulnerabilités',
    definition: 'Définition',
    proofs: 'Preuves',
    details: 'Détails',
    completed: 'Completé',
    type: 'Type',
    description: 'Description',
    observation: 'Observation',
    references: 'Références',
    one_per_line: '(Une par ligne)',
    customFields: 'Champs Personnalisés',
    affectedAssets: 'Actifs Impactés',
    courseOfActions: 'Plan d\'action',
    template: 'Modèle',
    client: 'Client',
    reviewers: 'Examinateurs',
    collaborator: 'Collaborateur',
    collaborators: 'Collaborateurs',
    startDate: 'Date de départ',
    endDate: 'Date de fin',
    reportingDate: 'Date de rapport',
    auditScope: 'Périmètre audité (Un hôte par ligne)',
    import: 'Importer',
    export: 'Exporter',
    hostsAssociateScopes: 'Associer des hôtes "importés" au périmètre défini',
    handleCustomData: 'Gérer les Données Personnalisées',
    clients: 'Clients',
    templates: 'Modèles',
    addClient: 'Ajouter un Client',
    editClient: 'Modifier un Client',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'E-mail',
    function: 'Fonction',
    phone: 'Téléphone',
    cell: 'Portable',
    jobTitle: 'Titre du poste',
    role: 'Rôle',
    collatorator: 'Collaborateur',
    addCollaborator: 'Ajouter un Collaborateur',
    editCollaborator: 'Modifier un Collaborateur',
    addCompany: 'Ajouter une Entreprise',
    editCompany: 'Modifier une Entreprise',
    logo: 'Logo',
    quantifier: '',
    languages: 'Langues',
    extension: 'Extension',
    createTemplate: 'Créer un Modèle',
    file: 'Fichier',
    editTemplate: 'Modifier un Modèle',
    importVulnerabilities: 'Importer des vulnérabilités',
    importVulnerabilitiesInfo: `Importez des vulnérabilités à partir d'un fichier .yml ou .json. (Format Serpico accepté)<br />
    Cela vous permet d'importer facilement un lot de modèles de vulnérabilités.`,
    importVulnerabilitiesOk: 'Les <strong>{0}</strong> vulnerabilités ont été créées',
    importVulnerabilitiesAllExists: 'Les <strong>{0}</strong> titres des vulnérabilités existent déjà',
    importVulnerabilitiesPartial: '<strong>{0}</strong> vulnérabilités créées<br /><strong>{1}</strong> titres des vulnérabilités existent déjà',
    exportVulnerabilities: 'Exporter les Vulnerabilités',
    exportVulnerabilitiesInfo: `Exporter les Vulnerabilités au format yaml. Cet export peut être facilement réimporté par la suite`,
    deleteAllVulnerabilities: 'Supprimer toutes les vulnérabilités',
    deleteAllVulnerabilitiesInfo: `Supprimer toutes les vulnérabilités existantes. <br />
    <strong>Cette action est définitive !!</strong>`,
    customSections: 'Sections personnalisées',
    listOfLanguages: 'Liste des Langues',
    editLanguages: 'Modifier les Langues',
    locale: 'Locale',
    auditTypesUsedInAudits: 'Types d\'Audit utilisés dans les Audits',
    languageUsedInAuditsAndVuls: 'Langues utilisées dans les audits et les vulnérabilités',
    addSections: 'Ajouter des Sections',
    hideBuiltInSections: 'Masquer les Sections Natives',
    listOfAuditTypes: 'Liste des Types d\'Audit',
    editAuditTypes: 'Modifier les Types d\'Audit',
    createAtLeastOneLanguage: 'Veuillez créer au moins une Langue',
    createVulnerabilityTypes: 'Créer des types de Vulnérabilité utilisés dans Vulnérabilités et Découvertes',
    vulnerabilityTypesList: 'Liste des types de Vulnérabilité',
    editVulnerabilityTypes: 'Modifier les types de Vulnérabilité',
    createVulnerabilityCategories: 'Créer des catégories de vulnérabilité utilisées dans Vulnérabilités et Découvertes',
    defaultSortingOptions: 'Options de Tri par Défaut',
    listOfCategories: 'Liste des Catégories',
    editCategories: 'Modifier les Catégories',
    createAndManageCustomFields: 'Créer et Gérer des Champs Personnalisés pour différentes Vues',
    selectView: 'Sélectionner une Vue',
    selectSection: 'Sélectionner une Section',
    selectComponent: 'Sélectionner un Composant',
    label: 'Label',
    size: 'Taille',
    offset: 'Décalage',
    required: 'Requis',
    optionsLanguage: 'Options de Langue',
    addOption: 'Ajouter une Option',
    languageForDefaultText: 'Langue (Pour le texte par défaut)',
    createCustomSections: 'Créer des sections personnalisées utilisées dans les Audits',
    fieldForTemplate: 'Champs (Pour les Modèles)',
    customIcon: 'Icons (Material/Font Awesome)',
    field: 'Champs',
    editSections: 'Modifier les Sections',
    vulnerabilityTypes: 'Types de Vulnérabilités',
    vulnerabilityCategories: 'Catégories de Vulnérabilité',
    auditGeneral: 'Audit General',
    auditFinding: 'Découverte d\'Audit',
    auditSection: 'Section d\'Audit',
    vulnerability: 'Vulnerabilité',
    checkbox: 'Checkbox',
    editor: 'Editeur',
    input: 'Input',
    radio: 'Radio',
    select: 'Select',
    selectMultiple: 'Sélectionner Plusieurs',
    space: 'Espace',
    updateUserInformation: 'Mettre à jour les Informations de l\'Utilisateur',
    newPassword: 'Nouveau Mot de Passe',
    confirmPassword: 'Confirmez le mot de passe ',
    currentPassword: 'Mot de passe actuel *',
    reports: 'Rapports',
    reportsImagesBorder: 'Bordures d\'Images de Rapport',
    addBorderToImages: 'Ajouter une bordure aux images dans le rapport généré.',
    currentColor: 'Couleur actuelle',
    cvssColors: 'Couleurs du CVSS',
    changeCvssColorsDescription: 'Modifier les couleurs utilisées dans le rapport pour représenter les différentes sévérités CVSS.',
    critical: 'Critique',
    informational: 'Informationnel',
    reviews: 'Commentaires',
    auditUpdateAfterApproval: 'Mise à jour de l\'Audit après Approbation',
    changeApproveBehaviorIfAuditUpdated: 'Modifier le comportement d\'un Audit approuvé qui est mis à jour. Si un audit est mis à jour: ',
    removeAllPriorApprovals: 'Toutes ses approbations préalables sont supprimées.',
    keepAllPriorApprovals: 'Toutes ses approbations préalables sont conservées.',
    mandatoryReview: 'Examen obligatoire',
    mandatoryReviewInfo: `Rend le processus de révision obligatoire. Lorsqu'il est activé, un utilisateur ne peut pas exporter un audit à moins qu'il n'ait été approuvé par le nombre spécifié d'examinateurs. 
    <br/>Le nombre minimal d'examinateurs est également utilisé pour déterminer si un rapport est marqué comme approuvé.`,
    minimalNumberOfReviewers: 'Nombre minimal d\'Examinateurs',
    saveSettings: 'Sauvegarder les paramètres',
    revertSettingsToDefaults: 'Rétablir les paramètres par défaut',
    importSettings: 'Importation des paramètres',
    exportSettings: 'Exportation des paramètres',
    mergeVulnerabilities: 'Fusionner les Vulnerabilités',
    mergeVulnerabilitiesInfo: `L'objectif est de fusionner différentes vulnérabilités dans différentes langues en une seule vulnérabilité.<br />
    Il doit donc exister un minimum de 2 langues.`,
    newVulnerability: 'Nouvelle vulnérabilité',
    total: 'Total',
    addVulnerability: 'Ajouter une Vulnérabilité',
    editVulnerability: 'Modifier une Vulnérabilité',
    changeCategory: 'Changer la Categorie',
    listOfSections: 'Liste des Sections',
    updateVulnerability: 'Mettre à jour la Vulnerabilité',
    current: 'Courant',
    languageAddFromRight: 'Langue (Ajouter à partir de la droite)',
    languageMoveToLeft: 'Langue (Déplacer vers la gauche)',
    merge: 'Fusionner',
    goBack: 'Revenir en arrière',
    twoStepVerification: 'Vérification en 2 étapes',
    twoStepVerificationMessage: "Ouvrez votre application d'authentification et entrez le code de sécurité correspondant.",
    captions: 'Légendes',
    captionsDescription: 'Ajouter les valeurs des différentes légendes qui seront utilisés dans le rapport (\'Figure\' par défaut).',
    highlightWarning: 'Alerte de Texte Surligné',
    highlightWarningDescription: `Ajoute un message d'avertissement lors de l'édition d'un rapport et que du texte surligné avec la couleur choisie est toujours présent.<br />
    Utile pour du texte générique qui devrait être remplacé par le rédacteur.`,
    defaultFieldsRequired: 'Champs par défaut',
    defaultFieldsRequiredDescription: 'Gestion des champs par défaut requis dans la section Audits',
    general: 'Général',
    scope: 'Périmètre',
    fieldIsRequired: 'Ce champ est requis',
    corrected: 'Corrigé',
    not_corrected: 'Non Corrigé',
    partially_corrected: 'Partiellement Corrigé',
    not_verifiable: 'Non Vérifiable',
    audits: 'Audits',
    multi: 'Multi-Phases',
    retest: 'Retest',
    default: 'Default',
    audit: 'Audit',
    originalAudit: 'Audit Original',
    willBeRemoved: 'sera retiré',
    auditPhase: 'Phase d\'Audit',
    upload: 'Importer',
    // Settings Backups
    backup: 'Sauvegarde',
    backups: 'Sauvegardes',
    backupInProgress: 'Sauvegarde en cours',
    backupOptions: 'Options de Sauvegarde',
    backupType: 'Type de Sauvegarde',
    createBackup: 'Créer Sauvegarde',
    customers: 'Clientèle',
    enableEncryption: 'Activer le chiffrement',
    full: 'Totalité',
    fullBackup: 'Sauvegarde totale',
    includeVulnerabilitiesUpdates: 'Inclure les propositions de mise à jour de vulnérabilités',
    listBackupDescription: 'Liste des sauvegardes disponibles sur le serveur',
    listBackups: 'Liste des Sauvegardes',
    neededForAuditTypes: "Requis pour les Types d'Audit",
    neededForClients: 'Requis pour les Clients',
    neededForVulnUpdates: 'Requis pour les propositions de mise à jour de vulnérabilités',
    partial: 'Partiel',
    partialBackup: 'Sauvegarde Partielle',
    refresh: 'Rafraichir',
    restore: 'Restaurer',
    restoreInProgress: 'Restauration en cours',
    restoreMode: 'Mode de Restauration',
    revert: 'Rétablir',
    selectWhatToRestore: 'Sélectionner quoi restaurer',
    upsert: 'Mettre à jour et insérer',
    vulnerabilities: 'Vulnérabilités',
    wrongFileFormat: 'Format de fichier incorrect',
    // Backups Statuses
    backup_started: 'Sauvegarde démarrée',
    backup_uploading: 'Importation de la sauvegarde en cours',
    dumping_database: 'Extraction de la base de donnée 1/3',
    building_data: 'Compilation des données 2/3',
    encrypting_data: 'Chiffrement des données 2.5/3',
    building_archive: "Construction de l'archive 3/3",
    backup_error: 'Erreur de Sauvegarde',
    restore_started: 'Restauration démarrée',
    extracting_info: 'Extraction des informations 1/3',
    decrypting_data: 'Déchiffrement des données 1.5/3',
    extracting_data: 'Extraction des données 2/3',
    restoring_data: 'Restoration des données 3/3',
    restore_error: 'La dernière restauration a généré une erreur',
    // Init restore message
    restoreFromBackup: 'Ou restaurer depuis un fichier de Sauvegarde',
    spellcheck: 'Correcteur orthographique',
    enableSpellcheck: 'Activer le correcteur',
    spellcheckCategories: 'Catégories',
    spellcheckCategory: {
        CASING: { label: 'Casse', description: 'Mauvaise capitalisation, ex. "anglais" au lieu de "Anglais"' },
        COMPOUNDING: { label: 'Composition', description: 'Erreurs avec les mots composés, ex. traits d\'union manquants' },
        GRAMMAR: { label: 'Grammaire', description: 'Erreurs grammaticales telles que formes verbales incorrectes' },
        TYPOS: { label: 'Fautes de frappe', description: 'Mots mal orthographiés et fautes de frappe courantes' },
        PUNCTUATION: { label: 'Ponctuation', description: 'Signes de ponctuation manquants ou incorrects' },
        TYPOGRAPHY: { label: 'Typographie', description: 'Problèmes typographiques comme des guillemets ou tirets incorrects' },
        CONFUSED_WORDS: { label: 'Mots confondus', description: 'Mots souvent confondus, ex. "a" vs "à"' },
        REPETITIONS: { label: 'Répétitions', description: 'Mots ou expressions involontairement répétés' },
        REDUNDANCY: { label: 'Redondance', description: 'Mots redondants n\'ajoutant aucune signification' },
        STYLE: { label: 'Style', description: 'Suggestions de style pour une écriture plus claire ou concise' },
        SEMANTICS: { label: 'Sémantique', description: 'Mots utilisés avec un sens incorrect' },
        COLLOQUIALISMS: { label: 'Expressions familières', description: 'Expressions informelles ou familières' },
        MISC: { label: 'Divers', description: 'Autres règles non couvertes par les catégories ci-dessus' },
    }
  }
